import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Spinner, Badge } from "react-bootstrap";

interface ProductData {
  product_name: string;
  total_sold: number;
  grand_total: number;
  status: string; // Status for badges
}

const TopSellingProductsTable: React.FC = () => {
  const [topSellingProducts, setTopSellingProducts] = useState<ProductData[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchTopSellingProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://api.sominnovations.xyz/Branches/top_selling_products/"
      );
      setTopSellingProducts(response.data);
    } catch (error) {
      console.error("Error fetching top-selling products:", error);
    }
    setLoading(false);
  };

  const formatCurrency = (value: number) =>
    new Intl.NumberFormat("en-KE", {
      style: "currency",
      currency: "KES",
    }).format(value);

  useEffect(() => {
    fetchTopSellingProducts();
  }, []);

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "Paid":
        return <Badge bg="success">Paid</Badge>;
      case "Out of date":
        return <Badge bg="danger">Out of Date</Badge>;
      case "Progress":
        return <Badge bg="warning" text="dark">In Progress</Badge>;
      default:
        return <Badge bg="secondary">Unknown</Badge>;
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h5 className="card-title text-center mb-4">Top Selling Products</h5>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table className="align-middle table-hover">
              <thead className="bg-light">
                <tr>
                  <th>Invoice ID</th>
                  <th>Category</th>
                  <th>Price</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {topSellingProducts.map((product, index) => (
                  <tr key={index} className="border-bottom">
                    <td>INV-{1990 + index}</td>
                    <td>{product.product_name}</td>
                    <td>{formatCurrency(product.grand_total)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopSellingProductsTable;
